import * as React from 'react';
import styled from 'styled-components';

import Colors from '../lib/Colors';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

function UnstyledButtonFooter(props: IProps) {
  return <footer className={props.className}>{props.children}</footer>;
}

const ButtonFooter = styled(UnstyledButtonFooter)`
  display: flex;
  height: 50px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  padding: 0.5rem;
  button {
    background-color: ${Colors.primary};
    &.secondary {
      background-color: ${Colors.secondary};
    }
    &.inverted {
      background-color: transparent;
      border: 0.1rem ${Colors.primary} solid;
      color: ${Colors.primary};
    }
    color: white;
    cursor: pointer;
    flex: 1;
    /* text-transform: uppercase; */
  }

  button + button {
    margin-left: 0.5rem;
  }
`;

export default ButtonFooter;



// WEBPACK FOOTER //
// ./src/components/ButtonFooter.tsx